import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Loader2 } from 'lucide-react';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in URL');
          navigate('/login');
          return;
        }

        const sessionId = sessionIdMatch[1];
        console.log('Processing Google OAuth session...');

        // Exchange session_id for user data via our backend
        // Use window.location.origin for OAuth to work across all environments
        const API_URL = window.location.origin;
        const response = await fetch(`${API_URL}/api/auth/google/callback`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId }),
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.detail || 'Authentication failed');
        }

        const data = await response.json();
        
        // Store user in context
        login(data.user);
        
        // Store token in localStorage for API calls
        if (data.token) {
          localStorage.setItem('roomhub_token', data.token);
          localStorage.setItem('roomhub_user', JSON.stringify(data.user));
        }

        console.log('Google OAuth successful, redirecting...');
        
        // Navigate based on user type
        if (data.user?.userType === 'verhuurder') {
          navigate('/verhuurder/dashboard', { replace: true });
        } else if (data.user?.hasPreferences === false) {
          // New user without preferences - go to onboarding
          navigate('/swipematch', { replace: true });
        } else {
          navigate('/swipematch/swipe', { replace: true });
        }
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/login', { 
          replace: true,
          state: { error: error.message }
        });
      }
    };

    processAuth();
  }, [location.hash, navigate, login]);

  return (
    <div className="min-h-screen bg-[#F7F7F7] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-[#2E7D32] mx-auto mb-4" />
        <p className="text-[#2A2A2A] font-medium">Even geduld...</p>
        <p className="text-[#9E9E9E] text-sm">Je wordt ingelogd via Google</p>
      </div>
    </div>
  );
};

export default AuthCallback;
